<template>
  <div :style="{width:width}">
    <div class="draw_title_c" @click="show=true">
      <span class="drawer_title" >{{changeTitle?selectData:title}}</span>
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
          <path d="M10 0L5 6L0 0H10Z" fill="white"/>
        </svg>
      </div>
    </div>
    <el-drawer :modal="false" direction="btt" custom-class="drawer-bg" :close-on-click-modal="false" :title="this.title" :visible.sync="show"
               :with-header="false"
               :append-to-body="true"
               size="225"
    >
      <div class="drawer">
        <div class="minus" @click="show=false"></div>
        <div class="content">
          <div v-for="(item,key) in list" :key="key" class="title_item" @click="select(item,key)">
            <div :class="'draw_sub_title ' + (selectIndex==key?'active':'')">{{item}}</div>
            <div :class="'draw_sub_right ' + (selectIndex==key?'active':'')">
              <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.625 13.9062C5.14062 13.9062 4.73698 13.7135 4.41406 13.3281L0.382812 8.44531C0.242188 8.28385 0.143229 8.1276 0.0859375 7.97656C0.0286458 7.82552 0 7.66927 0 7.50781C0 7.13802 0.122396 6.83333 0.367188 6.59375C0.617188 6.34896 0.929688 6.22656 1.30469 6.22656C1.72135 6.22656 2.06771 6.39583 2.34375 6.73438L5.59375 10.7578L11.9766 0.671875C12.138 0.427083 12.3047 0.255208 12.4766 0.15625C12.6536 0.0520833 12.8698 0 13.125 0C13.5 0 13.8099 0.119792 14.0547 0.359375C14.2995 0.598958 14.4219 0.901042 14.4219 1.26562C14.4219 1.40104 14.3984 1.54167 14.3516 1.6875C14.3047 1.83333 14.2318 1.98438 14.1328 2.14062L6.85938 13.2734C6.57292 13.6953 6.16146 13.9062 5.625 13.9062Z" fill="#C6FE61"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  props:{
    title:{
      type:String
    },
    list:{
      type:[]
    },
    onSelect:{
      type:Function
    },
    defaultSelect:{
      type:Number,
      default:0
    },
    changeTitle:{
      type:Boolean,
      default:true
    },
    width:{
      type:String,
      default:"100%"
    },
  },
  data(){
    return {
      show:false,
      selectData:this.list[this.defaultSelect],
      selectIndex:this.defaultSelect,
    }
  },
  methods:{
    setShow(isShow){
      this.show=isShow
    },
    select(item,key){
      if(this.$props.onSelect){
        console.log("props select is",this.$props.onSelect);
        this.$props.onSelect(item,key);
      }
      this.selectData=item;
      this.selectIndex=key;
      this.show=false;
    }
  }
}
</script>
<style scoped lang="less">
.draw_title_c{
  display: flex;
  align-items: center;
  justify-content: space-between;
  .drawer_title{
    color: #FFF;
    font-family: "SF Pro";
    font-size: 14px;
    font-style: normal;
    font-weight: 590;
    line-height: normal;
  }
}

.drawer {

  background: rgba(19, 20, 21, 1);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding-bottom: 60px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 8px;

  .minus {
    margin: auto;
    margin-bottom: 27px;
    width: 40px;
    height: 4px;
    border-radius: 2px;
    background: #232427;
  }
  .content{
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-left: 17px;
    margin-right: 17px;

  }

  .title_item{
    display: flex;
    justify-content: space-between;
    color:#737D8F;
    font-size: 16px;
    height: 45px;
    line-height: 45px;

    &.active{
      color:#C6FE61;
    }
    .draw_sub_title{
      &.active{
        color: #D3FF77;
      }
    }

    .draw_sub_right{
      display: none;
      &.active{
        display: block;
      }
    }

  }

  .item {
    margin-top: 14px;
    box-sizing: border-box
  }

  .el-drawer {
    background: transparent !important;
  }
  .open-amount-container{
    background: rgba(37, 40, 44, 1);
    border: none;
  }
}
::v-deep .el-drawer{
  background: transparent !important;
}
</style>